import React from 'react';
import PropTypes from 'prop-types';
import {Field} from 'redux-form';

import Form from '@appComponents/ReduxFormControls';

export const DistributionTypesFilter = ({
    distributionTypes = [],
    loading = false,
    filters,
    restoreFilterValues,
}) => (
    <Field
        className='--customWidth --distributionTypes'
        component={Form.ReduxSelect}
        disabled={loading}
        loading={loading}
        multiple
        name='distributionTypes'
        options={distributionTypes}
        placeholder='Distribution type'
        search
        setValue={restoreFilterValues(filters, 'distributionTypes')}
    />
);

DistributionTypesFilter.propTypes = {
    distributionTypes: PropTypes.array,
    loading: PropTypes.bool,
    filters: PropTypes.object.isRequired,
    restoreFilterValues: PropTypes.func.isRequired,
};
